<!-- 购买页 -->
<template>
  <div>
    <div v-loading="aloading" class="main_page">
      <div class="container">
        <div v-if="aloading" class="popLoading">
          <van-loading v-if="aloading" type="spinner" color="#999" size="24px" />
        </div>
        <!-- 加载中 -->
        <!-- <div class="topBox">
          <p class="title">{{ category_name }}</p>
            <p class="priceInfo">
              <span v-if="recieve_coupon_success && coupon_discount > 0 && coupon_discount_money > 0" class="origin_price">课程价：¥{{ price }}</span>
              <span v-else style="color: #ee2e2e;">课程价：<span class="price"><span class="dollar">¥</span>{{ price }}</span></span>
              <span class="origin_price">原价：¥{{ origin_price }}</span>
              <span class="tips">购买全科立享优惠折扣</span>
            </p>
        </div> -->
        <div class="topBox">
          <p class="title">{{ category_name }}</p>
          <!-- <p class="tips">购买全科立享优惠折扣</p>
          <p v-if="recieve_coupon_success && coupon_discount > 0" class="tips">用户等级折扣：{{ coupon_discount }}%</p>
          <p class="origin_price">原价：￥{{ origin_price }}</p>
          <p v-if="recieve_coupon_success && coupon_discount > 0 && coupon_discount_money > 0" class="origin_price">课程价￥{{ price }}</p>
          <p v-else class="priceInfo">课程价<span class="price"><span class="dollar">¥</span>{{ price }}</span></p>
          <p v-if="recieve_coupon_success && coupon_discount > 0 && coupon_discount_money > 0" class="use_coupon">优惠券：-¥{{ coupon_discount_money }}</p>
          <p v-if="recieve_coupon_success && coupon_discount > 0 && coupon_discount_money > 0" class="priceInfo">实付款：<span class="price"><span class="dollar">¥</span>{{ use_coupon_money }}</span></p> -->
        </div>
        <div class="midLists">
          <!-- （可多选） -->
          <p class="til">选择班型</p>
          <div class="classBox">
            <div v-for="(item,index) in classList" :key="index" :class="selClass.indexOf(item) > -1 ? 'item select' : 'item normal'" @click="selectClass(item)">
              <span>{{ item.name }}</span>
            </div>
          </div>
          <p class="til">选择科目（可多选）</p>
          <div class="classBox">
            <div v-for="(item1,index1) in lessonList" :key="index1" class="item">
              <template v-if="item1.state == -1">
                <!-- 禁选 -->
                <span class="disabledi">{{ item1.name }}</span>
              </template>
              <template v-else>
                <!-- 选中 -->
                <template v-if="item1.state == 1">
                  <span class="select" @click="selectLesson(item1)">{{ item1.name }}</span>
                </template>
                <!-- 普通 -->
                <template v-else>
                  <span class="normal" @click="selectLesson(item1)">{{ item1.name }}</span>
                </template>
              </template>
            </div>
          </div>
        </div>
        <div class="topBox">
          <!-- <p class="tips">购买全科立享优惠折扣</p>
          <p v-if="recieve_coupon_success && coupon_discount > 0" class="tips">用户等级折扣：{{ coupon_discount }}%</p> -->
          <p class="origin_price">原价：￥{{ origin_price }}</p>
          <p v-if="recieve_coupon_success && coupon_discount > 0 && coupon_discount_money > 0" class="origin_price">课程价：￥{{ price }}</p>
          <p v-else class="priceInfo">课程价：<span class="price"><span class="dollar">¥</span>{{ price }}</span></p>
          <p v-if="recieve_coupon_success && coupon_discount > 0 && coupon_discount_money > 0" class="use_coupon">优惠券：-¥{{ coupon_discount_money }}</p>
          <p v-if="recieve_coupon_success && coupon_discount > 0 && coupon_discount_money > 0" class="priceInfo">实付款：<span class="price"><span class="dollar">¥</span>{{ use_coupon_money }}</span></p>
        </div>
        <div class="botBox">
          <div  v-if="!recieve_coupon_success && coupon_discount > 0">
            <span class="buyBtn" @click="getCoupon">领取优惠券</span>
            <p style="margin: 0 0;color: #999;text-align: center;;">领取5折优惠券，可能还有惊喜哦~</p>
          </div>
          <span v-else class="buyBtn" @click="buySelect">立即购买</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { math } from '@/utils/math.js'
import { getPayConfig } from '@/api/zkbproEdu.js'
import Cookies from 'js-cookie'
import { getUserRankByuid, addCouponByUidRank } from '@/api/ucenterCouponTwo.js'

export default {
  components: {
  },
  data() {
    return {
      aloading: false,
      showPopLesson: false,
      category_name: this.$route.query.category_name || '',
      // 参数
      catid: this.$route.query.category_id || '', // 分类id
      onlymax: false,
      // 价格
      price: 0,
      origin_price: 0, // 原价
      // 课程
      lessonList: [],
      selLesson: [],
      // 班级
      classList: [],
      selClass: [],
      // 销售策略id
      strategyIdArr: [],
      // 可供选择的科目
      forCanSelectLesson: [],
      // 优惠券折扣信息
      coupon_discount: 0,
      recieve_coupon_success: false, // true 领取成功
      // 优惠券计算后的实付款
      use_coupon_money: '', // 用完优惠券的价格
      coupon_discount_money: '' // 优惠券优惠金额

    }
  },
  created() {
    this.getUserRankInfo()
    this.initValues()
    this.getDatas()
  },
  methods: {
    initValues() {
      this.origin_price = 0
      this.price = 0
      this.selClass = []
      this.selLesson = []
      this.strategyIdArr = []
      this.forCanSelectLesson = []
    },
    // 获取班型
    getDatas() {
      this.aloading = true
      getPayConfig({ category_id: this.catid, type: '1,2', onlymax: this.onlymax ? '1' : '0' }).then(res => {
        if (res.errNo === 0) {
          const result = res.result || {}
          this.category_name = result.category_name || ''
          const list = result.list || []
          const lessons = list[0] ? list[0].namelist || [] : []
          // 设置初始状态
          lessons.forEach(e => {
            e.state = -1
          })
          this.lessonList = lessons
          if (this.onlymax) {
            this.classList = [{ name: 'PRO班', is_qk: 0 }]
          } else {
            var class_list = list[1] ? list[1].namelist || [] : []
            // 手动过滤掉 小马领学营 和 猛虎小灶班
            class_list = class_list.filter((e) => e.name !== '小马领学营' && e.name !== '猛虎小灶班')
            this.classList = class_list
          }
        }
        this.aloading = false
      }).catch(() => {
        this.aloading = false
      })
    },
    // 选择班级
    selectClass(val) {
      // 更新选择信息时，清理下优惠信息
      this.resetCouponInfo()
      if (this.selClass.indexOf(val) > -1) {
        this.selClass.splice(this.selClass.indexOf(val), 1)
      } else {
        // 限制选一个
        this.selClass = []
        this.selClass.push(val)
      }
      // 每次选班型，置空已选的科目、销售策略id数组
      if (this.strategyIdArr.length > 0) {
        this.selLesson = []
        this.strategyIdArr = []
        this.changeListMenuState(null, false)
      } else {
        this.selLesson = []
        this.strategyIdArr = []
      }
      this.controlPrice()
      // 看当前选的班型下有多少科目
      if (this.selClass.length > 0) {
        var classNameArr = []
        this.selClass.forEach(e => {
          classNameArr.push(e.name)
        })
        this.aloading = true
        getPayConfig({ category_id: this.catid, type: '2', name: classNameArr.join(',') }).then(res => {
          if (res.errNo === 0) {
            const result = res.result || []
            this.lessonList.forEach(lesson => {
              lesson.state = result.filter(e => e.name === lesson.name).length ? 0 : -1
            })
            this.forCanSelectLesson = result
          }
          this.aloading = false
        }).catch(() => {
          this.forCanSelectLesson = []
          this.aloading = false
        })
      } else {
        this.forCanSelectLesson = []
      }
    },
    // 选择课程
    selectLesson(lesson) {
      if (this.selClass.length == 0) {
        return this.$toast('请先选择班型')
      }
      // 更新选择信息时，清理下优惠信息
      this.resetCouponInfo()
      const lesson_name = lesson.name
      // 是添加还是移除
      var isAdd = false
      // 选择的班型
      const class_name = this.selClass[0].name
      const cur_join_name = lesson_name + class_name
      if (this.selLesson.indexOf(lesson_name) > -1) {
        this.selLesson.splice(this.selLesson.indexOf(lesson_name), 1)
        const finds = this.strategyIdArr.filter(e => e.name === cur_join_name)
        if (finds.length > 0) {
          this.strategyIdArr.splice(this.strategyIdArr.indexOf(finds[0]), 1)
        }
        this.changeListMenuState(lesson, false)
        this.controlPrice()
      } else {
        isAdd = true
      }
      console.log(this.strategyIdArr)
      console.log(this.selLesson)
      // 选了班型，并且当前科目是选中
      if (isAdd) {
        this.getStrangeIdBySelect(lesson, class_name, true)
      }
    },
    // 获取组合 课程和班级 之后的销售策略
    getStrangeIdBySelect(lesson, class_name, isLesson) {
      /** 当前的规则是：
       * 1、只允许选择一个班型
       * 2、选择班型之后，选择科目，一个一个的选择
       * 3、切换班型时，置空 选择的科目、销售策略id
       * 4、请求接口时，先判断是否选了班型
      */
      var cur_join_name = ''
      if (isLesson) {
        cur_join_name = lesson.name + class_name
      }
      console.log(cur_join_name)
      this.aloading = true
      getPayConfig({ category_id: this.catid, type: '3', name: cur_join_name }).then(res => {
        if (res.errNo === 0) {
          const result = res.result || []
          if (result.length > 0) {
            const sale_strategy_id = result[0].sale_strategy_id || 0
            const combine_name = result[0].name || ''
            const price = result[0].price || ''
            const source_price = result[0].source_price || ''
            if (parseInt(sale_strategy_id) > 0) {
              this.strategyIdArr.push({
                name: cur_join_name,
                strategy_id: sale_strategy_id,
                price: price,
                source_price: source_price
              })
              this.controlPrice()
              if (isLesson) {
                this.selLesson.push(lesson.name)
                this.changeListMenuState(lesson, true)
              }
              console.log(this.strategyIdArr)
              console.log(this.selLesson)
            } else {
              this.$toast('该' + combine_name + '组合不存在')
            }
          } else {
            this.$toast('该组合不存在')
          }
        } else {
          this.$toast(res.msg || '接口请求失败')
        }
        this.aloading = false
      }).catch(() => {
        this.aloading = false
      })
    },
    // 修改列表的按钮状态
    changeListMenuState(lesson, isAdd) {
      if (isAdd) {
        // 添加课程
        this.lessonList.forEach(abc => {
          if (this.selLesson.indexOf(abc.name) > -1) {
          // 当前
            abc.state = 1
          } else {
          // 判断当前选的类型
            if (lesson.is_qk == 1) {
              abc.state = -1
            } else {
            // 当前选的不是全科
              if (abc.is_qk == 1) {
                abc.state = -1
              }
            }
          }
        })
      } else {
        // 移除课程
        this.lessonList.forEach(eee => {
          if (this.selLesson.indexOf(eee.name) > -1) {
          // 当前
            eee.state = 1
          } else {
            if (eee.state == 1) {
              eee.state = 0
            } else {
              if (this.selLesson.length === 0) {
                eee.state = this.forCanSelectLesson.filter(e => e.name === eee.name).length ? 0 : -1
              }
            }
          }
        })
      }
    },
    // 计算价格
    controlPrice() {
      // math
      if (this.strategyIdArr.length > 0) {
        this.price = 0
        this.origin_price = 0
        this.strategyIdArr.forEach(e => {
          const price_str = e.price || '0.0'
          const newprice = this.replaceAllFind(price_str, ',', '')
          this.price = math.add(this.price, newprice)
          const source_str = e.source_price || '0.0'
          const newsource_str = this.replaceAllFind(source_str, ',', '')
          this.origin_price = math.add(this.origin_price, newsource_str)
        })
        // 计算优惠券的优惠价格
        if (this.recieve_coupon_success && this.coupon_discount > 0) {
          const coupon_percent = math.divide(this.coupon_discount, 100)
          const new_price = math.multiply(this.price, coupon_percent)
          this.use_coupon_money = new_price
          // 优惠券优惠金额
          this.coupon_discount_money = math.subtract(this.price - new_price)
        }
      } else {
        this.resetCouponInfo()
        this.price = 0
        this.origin_price = 0
      }
    },
    resetCouponInfo() {
      this.recieve_coupon_success = false
      this.use_coupon_money = 0
      this.coupon_discount_money = 0
    },
    // 替换字符串
    replaceAllFind(str, find, replace) {
      return str.replace(new RegExp(find.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), replace)
    },
    // 购买
    buySelect() {
      // 先判断是否选择了
      if (this.strategyIdArr.length > 0) {
        console.log(this.strategyIdArr)
        var ids_arr = []
        this.strategyIdArr.forEach(e => {
          ids_arr.push(e.strategy_id)
        })
        const ids = ids_arr.join(',')
        const url = `${window.location.origin}/shop/pay/?product_type=7&product_id=${ids}&zkbpro=1&platform=11`
        window.location.href = url
      } else {
        this.$message.error('请先选择班型和科目')
      }
    },
    // 获取等级信息
    getUserRankInfo() {
      getUserRankByuid().then(res => {
        if (res.errNo == 0) {
          const result = res.result || {}
          const discount = parseInt(result.discount || '0')
          this.coupon_discount = discount
          console.log('coupon_discount = ', this.coupon_discount)
        } else {
          this.$message.error(res.msg || '')
          if (res.errNo == 2001) {
            this.showLogin()
          }
        }
      })
    },
    // 折扣计算
    parseDicount(discount) {
      // 检查是否为有效的数字并且在0到100之间
      if (typeof discount !== 'number' || discount < 0 || discount > 100) {
        return 0
      }
      // 计算折扣比例
      const result = discount / 10
      // 如果结果是整数，则直接返回；否则格式化为一位小数
      if (Number.isInteger(result)) {
        return result
      } else {
        // 使用 toFixed 方法并转换回数字以去除不必要的零
        return parseFloat(result.toFixed(1))
      }
    },
    // 领取优惠券
    getCoupon() {
      // 先判断登录没
      if (Cookies.get('uid')) {
        // 已登录
        if (this.strategyIdArr.length > 0) {
          // 调领取接口
          this.aloading = true
          var ids_arr = []
          this.strategyIdArr.forEach(e => {
            ids_arr.push(e.strategy_id)
          })
          const ids = ids_arr.join(',')
          const query = {
            product_id: ids,
            product_type: 7,
            type: 1
          }
          addCouponByUidRank(query).then(res => {
            if (res.errNo == 0) {
              console.log(res)
              this.recieve_coupon_success = true
              this.$message.success('领取成功')
              // 再次计算价格
              this.controlPrice()
            } else {
              this.$message.error(res.msg)
              if (res.errNo == 2001) {
                this.showLogin()
              }
            }
            this.aloading = false
          }).catch(() => {
            this.aloading = false
          })
        } else {
          this.$message.error('请先选择班型和科目')
        }
      } else {
        // 未登录
        this.showLogin()
      }
    },
    // 去登录
    showLogin() {
      const curr = window.location.href
      this.$router.replace({
        path: '/login',
        query: { redirect: decodeURIComponent(curr) }
      })
    }

  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.topBox {
  padding: 30px;
  width: 100%;
  // height: 180px;
  box-sizing: border-box;
  border-bottom: 2px solid #EFEFEF;
  p {
    margin: 0 0;
  }
  .title {
    height: 50px;
    line-height: 50px;
    font-family: PingFangSC-Medium;
    text-align: left;
    color: #333;
    font-size: 40px;
    font-weight: 500;
  }
  .priceInfo {
    font-family: PingFangSC-Medium;
    text-align: left;
    color: #ee2e2e;
    font-size: 28px;
    font-weight: 600;
  }
  .price {
    font-size: 40px;
  }
  .dollar {
    font-size: 32px;
  }
  .origin_price {
    margin-top: 6px;
    color: #999;
    font-size: 24px;
    text-decoration: line-through;
  }
  .use_coupon {
    margin-top: 6px;
    font-size: 24px;
    color: #999;
  }
  .tips {
    margin-top: 6px;
    font-size: 24px;
    color: #333;
  }
}
.midLists {
  padding: 20px 20px;
  width: calc(100% - 40px);
  // height: calc(100% - 360px);
  // overflow-y: scroll;
  border-bottom: 2px solid #EFEFEF;
  .til {
    color: #666;
    font-size: 28px;
    font-family: PingFangSC-Regular;
  }
  .classBox {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    .item {
      margin-right: 20px;
      margin-bottom: 28px;

    }
    .normal {
      display: inline-block;
      font-family: PingFangSC-Regular;
      padding: 8px 20px;
      min-width: 50px;
      border-radius: 30px;
      text-align: center;
      font-size: 28px;
      color: #333;
      background-color: #fff;
      border: 2px solid #999;
    }
    .select {
      display: inline-block;
      font-family: PingFangSC-Regular;
      padding: 8px 20px;
      min-width: 50px;
      border-radius: 30px;
      text-align: center;
      font-size: 28px;
      color: #fff;
      background-color: #ee2e2e;
      border: 2px solid #ee2e2e;
    }
    .disabledi {
      display: inline-block;
      font-family: PingFangSC-Regular;
      padding: 8px 20px;
      min-width: 50px;
      border-radius: 30px;
      text-align: center;
      font-size: 28px;
      color: #999;
      background-color: #eee;
      border: 2px solid #eee;
    }
  }

}
.botBox {
  width: 100%;
  // height: 140px;
  .recieveBtn {
    display: inline-block;
    margin: 20px 40px 0;
    height: 60px;
    line-height: 60px;
    width: calc(100% - 80px);
    // background-color: #ee2e2e;
    color: #ee2e2e;
    font-size: 30px;
    font-weight: 600;
    border-radius: 12px;
    text-align: center;
    font-family: PingFangSC-Medium;
  }
  .buyBtn {
    display: inline-block;
    margin: 40px 80px 20px;
    height: 70px;
    line-height: 70px;
    width: calc(100% - 160px);
    background-color: #ee2e2e;
    color: #fff;
    font-size: 30px;
    font-weight: 600;
    border-radius: 60px;
    text-align: center;
    font-family: PingFangSC-Medium;
  }
}
.popLoading {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  margin-top: -15%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
